<template>
  <div class="base-tip">
    <div class="only-border" :class="arrowClass"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'up'
    }
  },
  computed: {
    arrowClass () {
      return `arrow-${this.type}`
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.base-tip {
  background-color:rgba(0, 0, 0, 0);
  & .only-border {
    width: 0;
    height: 0;
    margin: 0 auto;
  }
  & .arrow-up {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid var(--colorWhite);
  }
  & .arrow-down {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid var(--colorWhite);
  }
  & .arrow-right {
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid var(--colorWhite);
  }
  & .arrow-left {
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent; 
    border-right: 5px solid var(--colorWhite);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tip/BaseTip.vue